// extracted by mini-css-extract-plugin
module.exports = {"button":"readMoreWrapper_button__2ZRWm","icon":"readMoreWrapper_icon__2x8_o","readMore":"readMoreWrapper_readMore__JM250","readLess":"readMoreWrapper_readLess__18dr9"};